import { Box, Divider, Grid, Paper, Typography } from '@mui/material';
import { FormEvent, MouseEvent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetValidationInfo, setValidationInfo } from 'redux/actions/internal/general/validation';
import { RootState } from 'redux/reducers';
import { useSignInProcess } from 'hooks/useSignInProcess';
import LoginContinueOptions from '../components/LoginContinueOptions';
import { useAuth } from 'context/authentication';
import useTranslation from 'next-translate/useTranslation';

interface IPhoneLoginPaperProps {
    onLogin?: (user: any) => void;
}

const PhoneLoginPaper = ({ onLogin }: IPhoneLoginPaperProps) => {
    const dispatch = useDispatch();
    const { t } = useTranslation('common');

    const { verifyPhoneNumber, checkPhone } = useAuth();

    const [loading, setLoading] = useState<boolean>(false);

    const usersLoginInfo = useSelector((state: RootState) => state.usersLoginInfo);
    const signInProcess = useSignInProcess();

    const handleVerify = (event: MouseEvent | FormEvent) => {
        event.preventDefault();
        setLoading(true);
        dispatch(resetValidationInfo('PHONE_VERIFICATION'));
        if (!usersLoginInfo.data.phone.phoneNumber) {
            setLoading(false);
            dispatch(setValidationInfo({ hasError: true, message: t('phoneNumberError') }, 'PHONE_VERIFICATION'));
            return;
        }

        checkPhone(`+${usersLoginInfo.data.phone.fullNumber}`).then(res => {
            if (res.success) {
                if (res.data.id) {
                    verifyPhoneNumber()
                        .signInWithPhoneNumber(usersLoginInfo.data?.phone.fullNumber)
                        .then(() => {
                            setLoading(false);
                            signInProcess.nextStep('CONFIRM_CODE');
                        })
                        .catch((error: Error) => {
                            setLoading(false);
                            dispatch(setValidationInfo({ hasError: true, message: error.message }, 'PHONE_VERIFICATION'));
                        });
                } else {
                    signInProcess.nextStep('REGISTER_INFO');
                }
            } else {
                dispatch(setValidationInfo({ hasError: true, message: res.data.message }, 'PHONE_VERIFICATION'));
            }
            setLoading(false);
        });

        // verifyPhoneNumber()
        //     .signInWithPhoneNumber(usersLoginInfo.data?.phone.fullNumber)
        //     .then(() => {
        //         setLoading(false);
        //         signInProcess.nextStep('CONFIRM_CODE');
        //     })
        //     .catch((error: Error) => {
        //         setLoading(false);
        //         dispatch(setValidationInfo({ hasError: true, message: error.message }, 'PHONE_VERIFICATION'));
        //     });
    };

    return (
        <Paper
            sx={{
                backgroundColor: theme => theme.palette.background.paper,
                boxShadow: theme => theme.shadows[5],
                width: '500px',
                display: 'flex',
                flexDirection: 'column',
                maxWidth: { xs: '90vw', lg: 'unset' },
                fontSize: { xs: '14px', lg: '1em' },
            }}
        >
            {/* {loadingVerification && <LinearProgress />} */}
            <Box
                sx={{
                    py: 4,
                    px: { xs: 2, lg: 10 },
                }}
            >
                <Grid container direction="column" alignItems="center">
                    <Grid item xs={12}>
                        <Typography>{t('signIn')}</Typography>
                    </Grid>
                    {/* <Grid item xs={12} style={{ width: '100%' }}>
                        <PhoneLogin message={t('phoneMessage')} onContinue={handleVerify} loading={loading} />
                    </Grid> */}
                </Grid>

                <Box mt={4}>
                    <Divider />
                </Box>

                <LoginContinueOptions onLogin={onLogin} />
            </Box>
        </Paper>
    );
};

export default PhoneLoginPaper;
